// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3NKeW","upload":"Small_upload__2ymrZ","imageWrap":"Small_imageWrap__3N7Ts","removeBtn":"Small_removeBtn__2mwqy"};